export enum PackageStatus {
  PENDING = 'Pending',
  APPROVED = 'Approved',
  ACQUIRED = 'Acquired',
  AT_SOURCE = 'AtSource',
  PICKED_UP = 'PickedUp',
  DELIVERING = 'Delivering',
  AT_DESTINATION = 'AtDestination',
  COMPLETED = 'Completed',
  NOT_DELIVERED = 'NotDelivered',
  CANCELED = 'Canceled'
}
